import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5601 7.83V6H31.6901V31.24H29.8601V30.44H30.8901V6.8H13.3601V7.83H12.5601ZM28.13 34.8H9V9.56H28.13V34.8ZM27.33 10.36H9.8V34H27.33V10.36Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol